'use strict';

const mapboxToken = 'pk.eyJ1IjoicmlnZXRoZW8iLCJhIjoiY210aW8xbDF1MDNhNDJ3cjV6cXl6cjFscyJ9.E1iaZTcLCrJIKmf8rHazrA';

const shareButton = document.querySelector('.kcjo-offer__share-button');

const addTogglePrevNextButtonsActive = (emblaApi, prevBtn, nextBtn) => {
	const togglePrevNextButtonsState = () => {
		prevBtn.toggleAttribute('disabled', !emblaApi.canScrollPrev());
		nextBtn.toggleAttribute('disabled', !emblaApi.canScrollNext());
	};

	togglePrevNextButtonsState();

	emblaApi.on('select', togglePrevNextButtonsState).on('reInit', togglePrevNextButtonsState);
};

const addPrevNextButtonClickHandlers = (emblaApi, prevBtn, nextBtn) => {
	prevBtn.addEventListener('click', () => emblaApi.scrollPrev(), false);
	nextBtn.addEventListener('click', () => emblaApi.scrollNext(), false);

	addTogglePrevNextButtonsActive(emblaApi, prevBtn, nextBtn);
};

const addDotButtonsAndClickHandlers = (emblaApi, dotsNode) => {
	let dotNodes = [];

	const addDotBtnsWithClickHandlers = () => {
		dotsNode.innerHTML = emblaApi
			.scrollSnapList()
			.map(
				(_, index) =>
					'<button class="kcjo-offer-carousel__dot" type="button" aria-label="Aller à la slide ' + (index + 1) + '"></button>'
			)
			.join('');

		dotNodes = Array.from(dotsNode.children);
		dotNodes.forEach((dotNode, index) => {
			dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false);
		});
	};

	const toggleDotButtonsActive = () => {
		const selected = emblaApi.selectedScrollSnap();
		dotNodes.forEach((dotNode, index) => dotNode.classList.toggle('is-selected', index === selected));
	};

	addDotBtnsWithClickHandlers();
	toggleDotButtonsActive();

	emblaApi.on('reInit', addDotBtnsWithClickHandlers).on('reInit', toggleDotButtonsActive).on('select', toggleDotButtonsActive);
};

// Scales each slide up as it nears the viewport's horizontal center and back
// down as it moves toward the edges, using --kcjo-carousel-scale (read by the
// slide's CSS transform; the custom property inherits down to it).
const addCenterScaleEffect = (emblaApi, viewportNode) => {
	const CENTER_SCALE = 1.08;
	const EDGE_SCALE = 0.92;

	const applyScale = () => {
		const viewportRect = viewportNode.getBoundingClientRect();
		const viewportCenter = viewportRect.left + viewportRect.width / 2;
		const halfViewport = viewportRect.width / 2;
		const slideNodes = emblaApi.slideNodes();

		const scales = slideNodes.map((slideNode) => {
			const slideRect = slideNode.getBoundingClientRect();
			const slideCenter = slideRect.left + slideRect.width / 2;
			const distanceRatio = Math.min(Math.abs(slideCenter - viewportCenter) / halfViewport, 1);

			return CENTER_SCALE - distanceRatio * (CENTER_SCALE - EDGE_SCALE);
		});

		slideNodes.forEach((slideNode, index) => {
			slideNode.style.setProperty('--kcjo-carousel-scale', scales[index].toFixed(3));
		});
	};

	applyScale();

	emblaApi.on('scroll', applyScale).on('reInit', applyScale).on('resize', applyScale);
};

if (shareButton) {
	const shareLabel = shareButton.querySelector('.kcjo-offer__share-label');
	const defaultLabel = shareLabel ? shareLabel.textContent : '';
	const copiedLabel = shareButton.dataset.copiedLabel || defaultLabel;

	shareButton.addEventListener('click', async () => {
		const shareData = {
			title: shareButton.dataset.shareTitle || document.title,
			url: shareButton.dataset.shareUrl || window.location.href
		};

		// Web Share API first (mobile browsers, most desktop browsers)
		if (navigator.share) {
			try {
				await navigator.share(shareData);
				return;
			} catch (error) {
				// User cancelled the share sheet, nothing else to do
				if (error && error.name === 'AbortError') return;
			}
		}

		// Copy-link fallback for browsers without the Web Share API (eg. Firefox desktop)
		try {
			await navigator.clipboard.writeText(shareData.url);

			shareButton.classList.add('is-copied');
			if (shareLabel) shareLabel.textContent = copiedLabel;

			setTimeout(() => {
				shareButton.classList.remove('is-copied');
				if (shareLabel) shareLabel.textContent = defaultLabel;
			}, 2000);
		} catch (error) {
			// Clipboard API unavailable/denied, nothing more we can do silently
		}
	});
}

const galleryViewport = document.querySelector('.kcjo-offer-gallery__viewport');
const galleryPrevButton = document.querySelector('.kcjo-offer-gallery__prev');
const galleryNextButton = document.querySelector('.kcjo-offer-gallery__next');
const galleryDots = document.querySelector('.kcjo-offer-gallery__dots');

if (galleryViewport && galleryPrevButton && galleryNextButton && typeof EmblaCarousel !== 'undefined') {
	const galleryEmbla = EmblaCarousel(galleryViewport, {
		align: 'start',
		slidesToScroll: 3,
		containScroll: 'trimSnaps',
		breakpoints: {
			'(max-width: 768px)': { slidesToScroll: 1 }
		}
	});

	addPrevNextButtonClickHandlers(galleryEmbla, galleryPrevButton, galleryNextButton);
	if (galleryDots) addDotButtonsAndClickHandlers(galleryEmbla, galleryDots);
	addCenterScaleEffect(galleryEmbla, galleryViewport);
}

const teamViewport = document.querySelector('.kcjo-offer-team__viewport');
const teamPrevButton = document.querySelector('.kcjo-offer-team__prev');
const teamNextButton = document.querySelector('.kcjo-offer-team__next');
const teamDots = document.querySelector('.kcjo-offer-team__dots');

if (teamViewport && teamPrevButton && teamNextButton && typeof EmblaCarousel !== 'undefined') {
	const teamEmbla = EmblaCarousel(teamViewport, {
		align: 'start',
		slidesToScroll: 5,
		containScroll: 'trimSnaps',
		breakpoints: {
			'(max-width: 768px)': { slidesToScroll: 2 }
		}
	});

	addPrevNextButtonClickHandlers(teamEmbla, teamPrevButton, teamNextButton);
	if (teamDots) addDotButtonsAndClickHandlers(teamEmbla, teamDots);
}

const clinicMapContainer = document.getElementById('kcjo-offer-clinic-map');
const clinicTabInput = document.getElementById('kcjo-offer-tab-clinique');
const clinicLocationScript = document.getElementById('kcjo-offer-clinic-location');

// The clinic map sits in a tab panel that's hidden (display: none) whenever another
// tab is active, so it can't be initialized until that panel is actually shown -
// mapbox-gl reads the container's size at creation time and never recovers from a 0x0 one.
if (clinicMapContainer && clinicTabInput && clinicLocationScript && typeof mapboxgl !== 'undefined') {
	let clinicMap;
	let clinicMapInitialized = false;

	function showClinicMap() {
		if (clinicMapInitialized) {
			clinicMap.resize();
			return;
		}

		clinicMapInitialized = true;

		let location;

		try {
			location = JSON.parse(clinicLocationScript.textContent);
		} catch (error) {
			return;
		}

		if (!location) return;

		clinicMap = new mapboxgl.Map({
			accessToken: mapboxToken,
			container: clinicMapContainer,
			center: [location.longitude, location.latitude],
			zoom: 14,
			minZoom: 5,
			projection: 'mercator',
			language: 'fr'
		});

		new mapboxgl.Marker({ color: '#11b2bd' }).setLngLat([location.longitude, location.latitude]).addTo(clinicMap);
	}

	clinicTabInput.addEventListener('change', () => {
		if (clinicTabInput.checked) showClinicMap();
	});

	if (clinicTabInput.checked) showClinicMap();
}

const offerTabs = document.querySelectorAll('.kcjo-offer-tabs__tab');

offerTabs.forEach((tab) => {
	const input = document.getElementById(tab.getAttribute('for'));

	if (!input) return;

	input.addEventListener('change', () => {
		offerTabs.forEach((otherTab) => {
			const otherInput = document.getElementById(otherTab.getAttribute('for'));
			otherTab.setAttribute('aria-selected', otherInput?.checked ? 'true' : 'false');
		});
	});
});

document.querySelectorAll('a[data-mail]').forEach((mailLink) => {
	// First click only reveals the address; the resulting mailto link then works normally
	mailLink.addEventListener(
		'click',
		(event) => {
			event.preventDefault();

			const email = mailLink.dataset.mail;

			mailLink.textContent = email;
			mailLink.href = `mailto:${email}`;
		},
		{ once: true }
	);
});
